import React, { FC, HTMLAttributes } from 'react';
import { Plan, PlanBadge, UsageBadge, Badge } from 'components/ui';
import routesByName from 'constants/routes';
import { Link } from 'react-router-dom';
import styles from './Navigation.module.scss';
import { t } from 'utils';
import classNames from 'classnames';

export interface INavigation extends HTMLAttributes<HTMLDivElement> {
  version: string;
  isPublic: boolean;
  plan: Plan;
  isPaid: boolean;
}

const Navigation: FC<INavigation> = (props) => {
  const { version, isPublic, plan, className, isPaid } = props;
  const rootClassName = classNames(styles.root, className);

  return (
    <div className={rootClassName}>
      <Link to={routesByName.apps.index} className={styles.backButton}>
        <span className='fas fa-th-large mr-2' />
        {t('back.to.apps')}
      </Link>
      <div className={styles.info}>
        <span className='mr-2'>v.{version}</span>
        {plan && <PlanBadge plan={plan} />}
        <UsageBadge isPublic={isPublic} />
        {isPaid && (
          <Badge
            className={classNames(styles.badge, styles.paid)}
            rootClassName='paid'
            icon='far fa-money-bill'
          />
        )}
      </div>
    </div>
  );
};

export default Navigation;
